function header_cart_price() {
  setTimeout(function() {
    fetch(`${window.location.href}`).then((response) => {
      return response.text();
    })
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html').querySelector('.header_total_price');
      document.querySelector('.header_total_price').innerHTML = html.innerHTML;
    })
    .catch(e => {
      console.error(e);
    })
    .finally(() => {
    });
  }, 50);
}

$(document).on("change",".custom-product .product-form__input select",function() {
  UpdateBasePrice();
});

$(document).on("click",".custom-product .product-form__input label",function() {
  UpdateBasePrice();
});

$(document).on("change",".custom-collection .product-form__input select",function() {
  CollectionUpdateBasePrice();
});

$(document).on("click",".custom-collection .product-form__input label",function() {
  CollectionUpdateBasePrice();
});

function UpdateBasePrice() {
  setTimeout(function() {
    var id = $('.product-variant-id').val();
    
    $('.base-price-row .hide').removeClass('show');
    $('.base-price-row .hide[data-id="'+id+'"]').addClass('show');
  }, 1500);
}

function CollectionUpdateBasePrice() {
  setTimeout(function() {
    var id = $('quick-add-modal .product-variant-id').val()
    debugger
    $('.base-price-row .hide').removeClass('show');
    $('.base-price-row .hide[data-id="'+id+'"]').addClass('show');
  }, 1500);
}



$("button.description-control-btn").click(function(){
  $(this).parent().toggleClass('active-now');
});